const TextColumn = require("components/columns/TextColumn");
const {moneyFormat} = require("helpers/format");

class CurrencyColumn extends TextColumn {

    get extraClassName () {
        return 'currency-column';
    }

    format(value) {
        if (typeof(this.props.formatter) === 'function') {
            return this.props.formatter(value);
        }

        if(!(typeof value === 'number')){
            value = parseFloat(value);
        }

        if(typeof value !== 'number' || isNaN(value)) {
            return null;
        }

        if(this.props.negate === true) {
            value *= -1;
        }

        return moneyFormat(value);
    }

}

module.exports = CurrencyColumn;
